
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useCreditTicketEdit } from '@/modules/credit/ticket/model/edit';
import { ROUTE_NAME_CREDIT } from '@/modules/credit/ticket/router';

export default defineComponent({
    name: ROUTE_NAME_CREDIT.TICKET.EDIT,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, update, fetch } = useCreditTicketEdit();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, update };
    }
});
